/**
 * Origin API z `appConfiguration.apiUrl` (np. `https://api.dev.redcurrant.eu/v1` →
 * `https://api.dev.redcurrant.eu`). `null` przy braku lub nieparsowalnym adresie —
 * wtedy interceptor działa jak przed ASMMNT-83 (nagłówki do każdego żądania), bo brak
 * filtra jest bezpieczniejszy niż zablokowanie logowania przez literówkę w konfiguracji.
 */
export const resolveApiOrigin = (
  apiUrl: string | null | undefined,
): string | null => {
  if (!apiUrl) return null;
  try {
    return new URL(apiUrl).origin;
  } catch {
    // Nieparsowalny adres (np. bez schematu) — patrz opis powyżej.
    return null;
  }
};
